"use client";

import { RoundNotifyMeButton } from "@faire/deprecated-retailer-visitor-shared/components/RoundNotifyMeButton/index";
import { NotifyMeProps } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/NotifyMe/NotifyMeProps";
import { useEventSubscriptionStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/EventSubscriptionStore";
import React from "react";
import styled from "styled-components";

export const NotifyMeBackInStockButton: React.FC<NotifyMeProps> = ({
  productOptionToken,
  productToken,
}) => {
  const { BackInStockIdentifiers } = useEventSubscriptionStore([
    "BackInStockIdentifiers",
  ]);

  const isSubscribedToBackInStock = !!(
    productOptionToken && BackInStockIdentifiers[productOptionToken]
  );

  const preventClickEvents = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <NotifyMeWrapper
      onClick={(e) => preventClickEvents(e)}
      key={`${productToken}-round-notify-me-picker`}
    >
      <RoundNotifyMeButton
        productOptionToken={productOptionToken ?? ""}
        isSubscribedToBackInStock={isSubscribedToBackInStock}
      />
    </NotifyMeWrapper>
  );
};

export const NotifyMeWrapper = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  z-index: 5;
`;
